<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="info" @click="backStoreOwner">返回</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Id" label="ID" width="100px"></el-table-column>
          <el-table-column prop="Orderid" label="提现单号"></el-table-column>
          <el-table-column prop="Nickname" label="提现账号">
            <template slot-scope="scope">
              <img :src="scope.row.Headimgurl" min-width="24" height="24" />
              昵称:{{scope.row.Nickname}}
            </template>
          </el-table-column>
          <el-table-column prop="Jine" label="提金额"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      keywords: {
        begintime: '',
        endtime: ''
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apiStoreOwnerTransferNum()
      this.apiStoreOwnerTransferList()
    },
    backStoreOwner () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiStoreOwnerTransferList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiStoreOwnerTransferNum()
      this.apiStoreOwnerTransferList()
    },
    apiStoreOwnerTransferList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: this.parentdata.params.jigouid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_StoreOwnerTransferList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiStoreOwnerTransferNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.parentdata.params.jigouid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_StoreOwnerTransferNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
